import type { FC } from 'react';
import Box from '@mui/material/Box';
import { FormProvider, useForm } from 'react-hook-form';
import { facebookPageValidator } from '../validation';
import type { z } from 'zod';
import FilterSearch from './FilterSearch';
import FacebookPagesGrid from './FacebookPagesGrid';
import { useListParams } from 'hooks';

type FormData = z.infer<typeof facebookPageValidator.schema>;

const FacebookSheets: FC = () => {
  const { q } = useListParams();

  const formMethod = useForm<FormData>({
    resolver: facebookPageValidator.resolver,
    defaultValues: {
      q: q ?? undefined,
    },
  });

  return (
    <FormProvider {...formMethod}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{ display: 'flex', width: '100%', flexDirection: 'row', gap: 2 }}
        >
          <Box sx={{ flex: 1, maxWidth: '40%' }}>
            <FilterSearch placeholder={'Search Facebook Page name or ID'} />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
            height: '100%',
            position: 'relative',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <FacebookPagesGrid />
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default FacebookSheets;
